import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { FooterComponent } from './footer/footer.component';
import { MenuComponent } from './menu/menu.component';
import { HomePageComponent } from './home-page/home-page.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ControlErrorComponent } from './shared/control-error/control-error.component';
import { ModalDialogComponent } from './shared/modal-dialog/modal-dialog.component';
import { ModalDialog2Component } from './shared/modal-dialog2/modal-dialog.component';
import { OfferFormComponent } from './offer-form/offer-form.component';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { ProvisoInfoComponent } from './proviso-info/proviso-info.component';
import { SwiperModule } from 'swiper/angular';
import { MatSelectModule } from '@angular/material/select';
import { A11yModule } from '@angular/cdk/a11y';
import * as $ from 'jquery';
import { HomePageFinishComponent } from './home-page-finish/home-page-finish.component';
import { CategoryComponent } from './category/category.component';
import { TextImg1Component } from './text-img-1/text-img-1.component';
import { TextImg2Component } from './text-img-2/text-img-2.component';
import { HomePageTeacherComponent } from './home-page-teacher/home-page-teacher.component';
import { HomePageParentComponent } from './home-page-parent/home-page-parent.component';
import { HomePageStudentComponent } from './home-page-student/home-page-student.component';
import { FullWidthImgComponent } from './full-width-img/full-width-img.component';
import { PlayLearnInfoComponent } from './play-learn-info/play-learn-info.component';
import { VideoFullWidthComponent } from './video-full-width/video-full-width.component';
import { MediaSliderComponent } from './media-slider/media-slider.component';
import { TextImgZebraComponent } from './text-img-zebra/text-img-zebra.component';
import { VideoGalleryCarouselComponent } from './video-gallery-carousel/video-gallery-carousel.component';
import { BackToRootComponent } from './back-to-root/back-to-root.component';
import { TextCarouselComponent } from './text-carousel/text-carousel.component';

@NgModule({
    declarations: [
        AppComponent,
        FooterComponent,
        MenuComponent,
        HomePageComponent,
        ControlErrorComponent,
        ModalDialogComponent,
        ModalDialog2Component,
        OfferFormComponent,
        ProvisoInfoComponent,
        HomePageFinishComponent,
        CategoryComponent,
        TextImg1Component,
        TextImg2Component,
        HomePageTeacherComponent,
        HomePageParentComponent,
        HomePageStudentComponent,
        FullWidthImgComponent,
        PlayLearnInfoComponent,
        VideoFullWidthComponent,
        MediaSliderComponent,
        TextImgZebraComponent,
        VideoGalleryCarouselComponent,
        BackToRootComponent,
        TextCarouselComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        SwiperModule,
        MatSelectModule,
        A11yModule
    ],
    providers: [{provide: LocationStrategy, useClass: PathLocationStrategy}],
    bootstrap: [AppComponent]
})
export class AppModule { }
